<div class="u-flex-column">
  <div class="col">
    <section class="u-flex-column">
      <div class="col-12">
        <mat-card
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_SHIPPING | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="flex u-flex-column gap-lg">
              <div>
                <h4>
                  {{ localizationConstants.SERVICE_REQUEST_STEP_SENDER | translate }}
                </h4>
                <table class="o-list-table o-list-table--compact">
                  <tr class="o-list-table__item">
                    <td
                      scope="row"
                      class="o-list-table__title">
                      {{ localizationConstants.SERVICE_REQUEST_STEP_COMPANY | translate }}
                    </td>
                    <td>
                      {{ companyName }}
                    </td>
                  </tr>
                  <ng-container>
                    <tr>
                      <td
                        scope="row"
                        class="o-list-table__title vertical-align-top">
                        {{ localizationConstants.SERVICE_REQUEST_STEP_ADDRESS | translate }}
                      </td>
                      <td class="u-pt--medium u-pre-line">
                        {{ currentShipFrom?.displayName }}
                      </td>
                    </tr>
                    <tr *ngIf="currentShipFrom?.address1">
                      <td
                        scope="row"
                        class="o-list-table__title"></td>
                      <td class="u-pt--medium">
                        {{ currentShipFrom?.address1 }}
                      </td>
                    </tr>
                    <tr *ngIf="currentShipFrom?.address2">
                      <td
                        scope="row"
                        class="o-list-table__title"></td>
                      <td class="u-pt--medium">
                        {{ currentShipFrom?.address2 }}
                      </td>
                    </tr>
                    <tr *ngIf="currentShipFrom?.address3">
                      <td
                        scope="row"
                        class="o-list-table__title"></td>
                      <td class="u-pt--medium">
                        {{ currentShipFrom?.address3 }}
                      </td>
                    </tr>
                  </ng-container>
                </table>
              </div>
              <div>
                <h4>
                  {{ localizationConstants.SERVICE_REQUEST_STEP_RECEIVER_TITLE | translate }}
                </h4>
                <table class="o-list-table o-list-table--compact">
                  <tr class="o-list-table__item">
                    <td
                      scope="row"
                      class="o-list-table__title">
                      {{ localizationConstants.SERVICE_REQUEST_STEP_SHOP | translate }}
                    </td>
                    <td class="o-list-table__description">
                      <div>{{ vendorNameToShow() }}</div>
                    </td>
                  </tr>
                </table>
              </div>
              <div *ngIf="ra.isShipmentRequested && showShipmentDetails">
                <h4 class="u-mt--small">
                  {{
                    localizationConstants.SERVICE_REQUEST_SHIPPING_PACKAGES_PICKUP_DATE | translate
                  }}
                </h4>
                <table class="o-list-table o-list-table--compact">
                  <tr class="o-list-table__item">
                    <td class="o-list-table__title">
                      {{ shipmentPickupDetails?.date | date }}
                    </td>
                    <td class="o-list-table__description">
                      {{ shipmentPickupDetails?.businessHours }}
                    </td>
                  </tr>
                </table>
                <h4 class="u-mt--medium">
                  {{
                    localizationConstants.SERVICE_REQUEST_STEP_SHIPPING_PACKAGES_REVIEW | translate
                  }}
                  ({{ packages()?.length }})
                </h4>
                <table class="o-list-table o-list-table--compact">
                  <ng-container *ngFor="let package of packages(); let i = index">
                    <tr class="o-list-table__item">
                      <td class="o-list-table__title">
                        {{ localizationConstants.SHIPPING_PACKAGES_PACKAGE_FORM_TITLE | translate }}
                        {{ i + 1 }}
                      </td>
                      <td class="o-list-table__description">
                        <div>
                          {{ parcelOptionsWithLabels[package.parcelType] | translate }} ({{
                            getDimensionsLabel(package.parcelType, customerSettings.unitOfMeasure)
                          }}
                          {{ lengthUnitTranslation | translate }})
                        </div>
                      </td>
                      <td class="o-list-table__description">
                        <div>{{ package.weight }} {{ weightUnitTranslation | translate }}</div>
                      </td>
                      <td class="o-list-table__description">
                        <div>{{ package.description }}</div>
                      </td>
                    </tr>
                  </ng-container>
                </table>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-divider></mat-divider>
      <div class="col-12">
        <mat-card
          appearance="outlined"
          class="stepper-card">
          <mat-card-header>
            <mat-card-title>
              {{ localizationConstants.SERVICE_REQUEST_STEP_DETAILS | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div>
              <h4>
                {{ localizationConstants.SERVICE_REQUEST_STEP_CONTACT_TITLE | translate }}
              </h4>
              <table class="o-list-table o-list-table--compact">
                <tr class="o-list-table__item">
                  <td
                    scope="row"
                    class="o-list-table__title">
                    {{ localizationConstants.SERVICE_REQUEST_STEP_CONTACT_NAME | translate }}
                  </td>
                  <td class="o-list-table__description">
                    <div>{{ ra.fromContact }}</div>
                  </td>
                </tr>
                <tr class="o-list-table__item">
                  <td
                    scope="row"
                    class="o-list-table__title">
                    {{ localizationConstants.SERVICE_REQUEST_CONTACT_EMAIL | translate }}
                  </td>
                  <td class="o-list-table__description">
                    <div>{{ ra.customerEmail }}</div>
                  </td>
                </tr>
                <tr class="o-list-table__item">
                  <td
                    scope="row"
                    class="o-list-table__title">
                    {{ localizationConstants.SERVICE_REQUEST_CONTACT_PHONE | translate }}
                  </td>
                  <td class="o-list-table__description">
                    <div>{{ ra.phoneNumber }}</div>
                  </td>
                </tr>
              </table>
            </div>

            <div class="u-mt--medium">&nbsp;</div>

            <div>
              <h4>
                {{ localizationConstants.SERVICE_REQUEST_STEP_DOCUMENTS | translate }}
              </h4>
              <div>
                <span>{{ ra.document?.fileName }}</span>
              </div>
            </div>

            <div class="u-mt--medium">&nbsp;</div>

            <div>
              <h4>
                {{ localizationConstants.SERVICE_REQUEST_STEP_PURCHASE_ORDER_TITLE | translate }}
              </h4>
              <table class="o-list-table o-list-table--compact">
                <tr class="o-list-table__item">
                  <td class="o-list-table__description">
                    <div>{{ ra.poNumber }}</div>
                  </td>
                </tr>
              </table>
            </div>
            <div class="u-mt--medium">&nbsp;</div>

            <div *ngIf="!ra.isShipmentRequested">
              <h4>
                {{ localizationConstants.SERVICE_REQUEST_STEP_TRACKING_NUMBER_TITLE | translate }}
              </h4>
              <table class="o-list-table o-list-table--compact">
                <tr class="o-list-table__item">
                  <td class="o-list-table__description">
                    <div>{{ ra.trackingNumber }}</div>
                  </td>
                </tr>
              </table>
            </div>

            <div>
              <h4>
                {{ localizationConstants.SERVICE_REQUEST_STEP_REMARKS | translate }}
              </h4>
              <table class="o-list-table o-list-table--compact">
                <tr class="o-list-table__item">
                  <td
                    class="o-list-table__description"
                    colspan="2">
                    <div>{{ ra.commentsToShow }}</div>
                  </td>
                </tr>
              </table>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </section>
  </div>
</div>
